import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { externalChannelByIdQuery } from '@/entities/channel/queries';
import { IExternalChannelQrResponseDTO } from '@/shared/api/channels';

export function useExternalChannelById(
  channelId?: string,
  options?: Omit<
    UseQueryOptions<IExternalChannelQrResponseDTO>,
    'queryFn' | 'queryKey'
  >
) {
  const { data, ...otherQueryData } = useQuery<IExternalChannelQrResponseDTO>({
    ...externalChannelByIdQuery(channelId!),
    ...options,
    enabled: options?.enabled ? options.enabled && !!channelId : !!channelId,
  });

  return { channelByIdData: data, ...otherQueryData };
}
